module.exports = __webpack_public_path__ + "cd1d96252acabea2e36c73705b406876.png";